module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/icon-step-3@2x_c3177611b71c9b940d3bdb82058ec758.png";